import {
  savingsOpportunityAccountColumnField,
  savingsOpportunityCloudProviderColumnField,
  savingsOpportunityResourceArnColumnField,
} from "@/components/pages/savings-opportunities/components/savingsOpportunitiesTableColumns";

export const billingExplorerSavingOpportunitiesDefaultHiddenColumns = new Set([
  "action_type",
  "implementation_effort",
  savingsOpportunityCloudProviderColumnField,
  "resource_type",
  "recommended_type",
  "resource_id",
  savingsOpportunityResourceArnColumnField,
  "based_on_past",
  "region",
  "tags",
  "task",
  savingsOpportunityAccountColumnField,
]);
